// src/App.js
import React from 'react';
import { Container, Toolbar, Box } from '@mui/material';
import NavBar from './components/layouts/NavBar';
import AppRouting from './app-routing';

export default function App() {
  return (
    <Box className="h-100" sx={{ backgroundColor: '#F9F9F9', minHeight: '100vh' }}>
      <NavBar />
      <Toolbar />
      <Container className="mt-md-5" sx={{ backgroundColor: 'transparent' }}>
        <AppRouting />
      </Container>
    </Box>
  );
}
